var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-type goodbad-wrapper"},[(_vm.dataStore.activeType == 'image')?_c('image-editor'):_vm._e(),_vm._v(" "),(_vm.dataStore.activeType == 'map')?_c('map-editor'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }